import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class DashboardsAlertsService {

  constructor(private bringozToastService: BringozToastService) {
  }

  createDashboardSuccess() {
    const message = {
      body: 'DASHBOARD_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message, null, null)
  }

  createDashboardError() {
    const message = {
      body: 'DASHBOARD_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateDashboardSuccess() {
    const message = {
      body: 'DASHBOARD_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message, null, null)
  }

  updateDashboardError() {
    const message = {
      body: 'DASHBOARD_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteDashboardSuccess() {
    const message = {
      body: 'DASHBOARD_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message, null, null)
  }

  deleteDashboardError() {
    const message = {
      body: 'DASHBOARD_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getDashboardWidgetDataError(widgetName: string) {
    const message = {
      body: 'GET_DASHBOARD_WIDGET_DATA_ERROR',
    };
    return this.bringozToastService.error(message, {widgetName}, 'Retry');
  }



}

angular
  .module('bringoz.admin.dashboards')
  .service('dashboardsAlertsService', DashboardsAlertsService);
